module.exports = __webpack_public_path__ + "static/blackberry-b9767c0601dd6c39140f289da0bf896b.svg";